import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../ts/Glob';
import { AppSettingsFlatCheckList, IMarkedItemsBoolean } from '../AppSettingsFlatCheckList';
import { createNodeID, IExportStore, parseNodeID } from '../../../../_common/platform/ts/exportImportDispatcher';
import { ITreeNode } from '../../ts/Interfaces';

export interface IThemesExportData {
    themes?: number[];
}

export default function ThemesExport(props: {
    value: { themes?: number[] };
    glob: IGlob;
    onChange(value: IThemesExportData, selectedItems: any[]): void;
}) {
    const themeState = props.glob.ThemeStore.useSimpleStoreStateHook();
    const [value, setValue] = React.useState(props.value?.themes);

    const handleOnChange = React.useCallback(
        (marked: IMarkedItemsBoolean) => {
            const newValue = Object.keys(marked).map((key) => parseInt(key));

            setValue(newValue);

            if (props.onChange != null) {
                props.onChange({ themes: newValue }, newValue);
            }
        },
        [props.onChange]
    );

    const values = _.map(themeState.themesHash, (value) => {
        return {
            key: value.id.toString(),
            value: value.name
        };
    }).sort((value1, value2) => value1?.value?.localeCompare(value2?.value));

    const marked: IMarkedItemsBoolean = {};

    _.each(value, (item) => {
        marked[item.toString()] = true;
    });

    return (
        <div className="app-settings-export">
            <AppSettingsFlatCheckList value={values} marked={marked} onChange={handleOnChange} />
        </div>
    );
}

export const THEMES_EXPORT_ID = 'themes';

const THEMES_TYPE = 'theme';

export class ThemesExportStore implements IExportStore {
    private _glob: IGlob;

    constructor(glob: IGlob) {
        this._glob = glob;
    }

    public get descriptionID(): string {
        return THEMES_EXPORT_ID;
    }

    public createExportData(values: string[]) {
        const result: IThemesExportData = {};
        const themes: number[] = [];

        values?.forEach((value) => {
            const { type, id } = parseNodeID(value);

            if (type === THEMES_TYPE) {
                themes.push(parseInt(id));
            }
        });

        if (themes.length > 0) {
            result.themes = themes;
        }

        return result;
    }

    public async getItemsToExport(): Promise<ITreeNode[]> {
        return new Promise((resolve, reject) => {
            const themeState = this._glob.ThemeStore.getState();
            const result = _.map(themeState.themesHash, (value) => {
                const nodeID = createNodeID(THEMES_EXPORT_ID, THEMES_TYPE, value.id.toString());
                const result: ITreeNode = {
                    key: nodeID,
                    id: nodeID,
                    title: value.name
                };
                return result;
            }).sort((value1, value2) => value1?.title?.localeCompare(value2?.title));

            resolve(result);
        });
    }
}
